import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Control, useFieldArray } from "react-hook-form";
import AutomatedNotificationItem from "./AutomatedNotificationItem";
import { AuthStateAudienceSelection } from "./AutomatedNotificationsForm";

type AutomatedNotificationsGroupProps = {
  title: string;
  formName: string;
  register: any;
  errors: any;
  control: Control<any>;
  watch: any;
  delayOptions: { value: number; label: string }[];
  isAppClip?: boolean;
  showLandingPath: boolean;
};

const AutomatedNotificationsGroup = ({
  title,
  formName,
  register,
  errors,
  control,
  watch,
  delayOptions,
  isAppClip,
  showLandingPath,
}: AutomatedNotificationsGroupProps) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: formName,
  });

  const handleAddNotification = () => {
    append({
      title: "",
      message: "",
      delayMinutes: 60, // Default to 1 hour
      isEnabled: true,
      audience: AuthStateAudienceSelection.EVERYONE,
    });
  };

  const handleDeleteNotification = (index: number) => {
    remove(index);
  };

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 3,
        mb: 3,
        background: "#fff",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2} mb={3}>
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
        <Box flexGrow={1} />
      </Stack>

      <Stack spacing={2}>
        {fields.map((field, index) => (
          <AutomatedNotificationItem
            key={field.id}
            index={index}
            groupName={title}
            formName={`${formName}.${index}`}
            register={register}
            errors={errors?.[formName]?.[index]}
            control={control}
            watch={watch}
            onDelete={() => handleDeleteNotification(index)}
            delayOptions={delayOptions}
            isAppClip={isAppClip}
            showLandingPath={showLandingPath}
          />
        ))}
      </Stack>

      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={handleAddNotification}
        sx={{ mt: 2 }}
        fullWidth
      >
        Add Notification
      </Button>
    </Box>
  );
};

export default AutomatedNotificationsGroup;
